module.exports = __webpack_public_path__ + "static/media/OutliersQ5_5.573fc879.svg";